/**
 * UI panel visibility — controls mobile drawers for sidebar and right panel.
 *
 * On large screens (lg+, xl+) the panels are statically rendered; this store
 * is only consulted on smaller viewports where they become drawers.
 */

import { useSyncExternalStore } from 'react';

interface PanelsState {
  sidebarOpen: boolean;
  rightOpen: boolean;
}

let state: PanelsState = { sidebarOpen: false, rightOpen: false };
const listeners = new Set<() => void>();

function emit() {
  for (const l of listeners) l();
}

export function setSidebarOpen(open: boolean) {
  state = { ...state, sidebarOpen: open };
  emit();
}

export function setRightOpen(open: boolean) {
  state = { ...state, rightOpen: open };
  emit();
}

export function usePanels(): PanelsState {
  return useSyncExternalStore(
    (l) => {
      listeners.add(l);
      return () => listeners.delete(l);
    },
    () => state,
    () => state
  );
}
